import React from 'react';
import { useIntl } from 'react-intl';
import { Button } from '@eventbrite/marmalade';
import { DOM_IDS, LISTING_HEAP_IDS, STATSIG_EVENT_NAMES } from '../../_shared/constants';
import styles from './ExploreSimilarEventsButton.module.scss';
import { logEvent } from '@eventbrite/legacy-infra.statsig';

export const ExploreSimilarEventsButton: React.FC = () => {
  const { formatMessage } = useIntl();

  const label = formatMessage({ id: 'Explore similar events' });

  const handleScrollToRelatedEvents = () => {
    logEvent(STATSIG_EVENT_NAMES.LISTING_CONVERSION_BAR_CTA_CLICK);
    const relatedEventsElement = document.getElementById(DOM_IDS.RELATED_EVENTS);

    if (!relatedEventsElement) {
      console.warn('Related events section not found - element may not be loaded yet');
      return;
    }

    try {
      relatedEventsElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    } catch (error) {
      console.error('Error scrolling to related events:', error);
      // Fallback to simple scroll
      try {
        relatedEventsElement.scrollIntoView();
      } catch (fallbackError) {
        console.error('Fallback scroll also failed:', fallbackError);
      }
    }
  };

  return (
    <Button
      className={styles.exploreSimilarEventsButton}
      variant="primary"
      onClick={handleScrollToRelatedEvents}
      data-heap-id={LISTING_HEAP_IDS.EXPLORE_SIMILAR_EVENTS}
      data-testid="explore-similar-events-button"
    >
      {label}
    </Button>
  );
};
